import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILoginParams } from '../types/ILoginParams';
import { ISessionInfo } from '../types/ISessionInfo';

export class LoginRequest extends Request<ILoginParams, ISessionInfo> {
  constructor(params: ILoginParams) {
    super('login', params);
  }
}
